import { useStore, useMemoCompare } from "../../../services/hooks";
import { Typography, Box, TextField, Divider } from "@mui/material";

const extractAllImgSrcs = (html) => {
  if (!html) return [];
  const regex = /<img[^>]+src=["']([^"']+)["']/gi;
  const srcs = [];
  let match;
  while ((match = regex.exec(html))) {
    srcs.push(match[1]);
  }
  return srcs;
};

const ViewItemImageAssetsCard = () => {
  const [item] = useStore("item");
  const imageAssetsArray = useMemoCompare(item?.imageAssets);
  const content = item?.content;

  const contentImgSrcs = extractAllImgSrcs(content);

  const foilImgSrcs = Array.isArray(item?.interactions)
    ? item.interactions.flatMap((interaction) =>
        Array.isArray(interaction.foils)
          ? interaction.foils.flatMap((foil) => extractAllImgSrcs(foil.content))
          : [],
      )
    : [];

  const allImgSrcs = [...contentImgSrcs, ...foilImgSrcs];

  const matchingAssets =
    Array.isArray(imageAssetsArray) && allImgSrcs.length
      ? imageAssetsArray.filter((a) => allImgSrcs.includes(a.src))
      : [];

  if (!matchingAssets.length) {
    return (
      <Box
        sx={{
          maxWidth: 600,
          margin: "auto",
          p: 3,
          bgcolor: "background.paper",
          borderRadius: 2,
        }}
      >
        <Typography variant="h6">
          No matching image assets found in content.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
        justifyContent: "center",
        width: "100%",
      }}
    >
      {matchingAssets.map((imageAsset, idx) => (
        <Box
          key={imageAsset.identifier}
          sx={{
            width: "100%",
            p: 3,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 1,
            mb: 2,
          }}
        >
          {imageAsset.src && (
            <Box
              component="img"
              src={imageAsset.src}
              alt={imageAsset.name || "imageAsset"}
              sx={{
                width: "100%",
                maxHeight: 300,
                objectFit: "contain",
                mb: 2,
                borderRadius: 1,
              }}
            />
          )}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Identifier"
              value={imageAsset.identifier || ""}
              fullWidth
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
            <TextField
              label="Name"
              value={imageAsset.name || ""}
              fullWidth
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
            <TextField
              label="Alt Text"
              value={imageAsset.altText || ""}
              fullWidth
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
            <TextField
              label="Long Description"
              value={imageAsset.longDescription || ""}
              fullWidth
              multiline
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
          </Box>
          {idx < matchingAssets.length - 1 && <Divider sx={{ mt: 3 }} />}
        </Box>
      ))}
    </Box>
  );
};

export { ViewItemImageAssetsCard };
